module.exports = __webpack_public_path__ + "img/bg-dialog@3x.6692edf4.png";